/* Native navigation disclosures: one open panel, outside-click and Escape dismissal. */
(function () {
  const navigation = document.querySelector('.cat-nav--organized');
  if (!navigation) return;
  const disclosures = navigation.querySelectorAll('.nav-disclosure');
  for (const disclosure of disclosures) {
    disclosure.addEventListener('toggle', () => {
      if (!disclosure.open) return;
      for (const other of disclosures) {
        if (other !== disclosure) other.open = false;
      }
    });
  }
  document.addEventListener('click', (event) => {
    if (navigation.contains(event.target)) return;
    for (const disclosure of disclosures) disclosure.open = false;
  });
  navigation.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    for (const disclosure of disclosures) {
      if (!disclosure.open) continue;
      disclosure.open = false;
      disclosure.querySelector('summary').focus();
      event.preventDefault();
    }
  });
})();

/* LUVEE theme — cart drawer + AJAX add-to-cart */
(function () {
  const $ = (s) => document.querySelector(s);
  const overlay = $('#overlay'), drawer = $('#cart-drawer'), mnav = $('#m-nav');
  /* One money format everywhere — the twin of snippets/price.liquid. ₹349 for whole rupees,
     ₹389.35 when there are paise. toLocaleString alone printed ₹558.4 in the cart drawer. */
  window.luveeMoney = (cents) => { const c = Math.round(Number(cents) || 0); const p = c % 100 !== 0;
    return '₹' + (c / 100).toLocaleString('en-IN', { minimumFractionDigits: p ? 2 : 0, maximumFractionDigits: p ? 2 : 0 }); };
  /* Savings — the twin of snippets/price-savings.liquid; change both together. saving = compare − price,
     percent = floor(saving × 100 / compare): floored, never rounded up, so a saving is never overstated.
     null when there is no saving. `text` is "Save ₹50 (5%)" — "Save ₹50" when withPercent is false or
     the saving is under 1% — and `html` is the save-line element. Amounts in paise. */
  window.luveeSaving = (price, compare, withPercent = true) => {
    const p = Math.round(Number(price) || 0), c = Math.round(Number(compare) || 0);
    if (!(c > p)) return null;
    const amount = c - p, percent = Math.floor((amount * 100) / c);
    const text = 'Save ' + window.luveeMoney(amount) + (withPercent && percent > 0 ? ` (${percent}%)` : '');
    return { amount, percent, text, html: `<span class="price-save">${text}</span>` };
  };
  const money = (c) => window.luveeMoney(c);
  const escapeHtml = (value) => String(value == null ? '' : value).replace(/[&<>\"]/g, (character) =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[character]));
  let menuReturnFocus = null;

  function openDrawer() { renderCart(); drawer.classList.add('is-open'); overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { drawer.classList.remove('is-open'); overlay.classList.remove('is-open'); document.body.style.overflow = ''; }
  function menuFocusables() {
    if (!mnav) return [];
    return [...mnav.querySelectorAll('a[href], button, input, select, textarea, summary, [tabindex]')]
      .filter((el) => !el.disabled && el.tabIndex >= 0 && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
  }
  function openMenu() {
    if (!mnav || mnav.classList.contains('is-open')) return;
    menuReturnFocus = document.activeElement;
    mnav.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    const t = $('#menu-toggle');
    if (t) t.setAttribute('aria-expanded', 'true');
    const initialFocus = $('#m-nav-close') || menuFocusables()[0];
    if (initialFocus) initialFocus.focus({ preventScroll: true });
  }
  function closeMenu() {
    const wasOpen = mnav && mnav.classList.contains('is-open');
    if (mnav) mnav.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    const t = $('#menu-toggle');
    if (t) t.setAttribute('aria-expanded', 'false');
    if (wasOpen) {
      const returnFocus = menuReturnFocus && menuReturnFocus.isConnected ? menuReturnFocus : t;
      if (returnFocus && returnFocus.getClientRects().length) returnFocus.focus({ preventScroll: true });
      menuReturnFocus = null;
    }
  }
  function closeAll() { closeDrawer(); closeMenu(); }

  /* Free surprise gift — display only, mirrors snippets/cart-gift.liquid on the cart page.
     Never rendered for an empty bag (renderCart returns before this) and never sent to
     /cart/add.js: nothing is added, nothing is discounted, no stock moves. The gift is
     packed by hand. Copy + on/off come from theme settings via window.LUVEE.gift. */
  function giftRow() {
    const g = (window.LUVEE && window.LUVEE.gift) || {};
    if (!g.on) return '';
    const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) =>
      ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    return `
      <div style="display:flex;gap:12px;align-items:center;padding:14px 0 4px;margin-top:4px;border-top:1px dashed var(--accent)">
        <div style="flex:none;width:40px;height:40px;border-radius:9px;background:#fff;border:1px dashed var(--accent);display:flex;align-items:center;justify-content:center;font-size:19px">🎁</div>
        <div style="flex:1;min-width:0">
          <div style="font-size:13.5px;font-weight:600;line-height:1.3">${esc(g.title)}</div>
          <div class="muted" style="font-size:12px;margin-top:2px">${esc(g.sub)}</div>
        </div>
        <div style="font-size:11.5px;font-weight:700;letter-spacing:.08em;color:var(--accent);white-space:nowrap">FREE</div>
      </div>`;
  }

  function shippingProgress(totalPrice) {
    if (!window.LUVEEShippingProgress) return '';
    const copy = (window.LUVEE && window.LUVEE.shipping) || {};
    const state = window.LUVEEShippingProgress.forTotal(totalPrice, {
      remaining: copy.remaining || 'Add [amount] more and delivery drops to ₹49.',
      unlocked: copy.unlocked || '₹49 shipping applies to this order.'
    });
    return `
      <div class="shipping-progress${state.isUnlocked ? ' shipping-progress--unlocked' : ''}">
        <p class="shipping-progress__message" role="status" aria-live="polite">${escapeHtml(state.message)}</p>
        <progress class="shipping-progress__bar" max="${state.thresholdCents}" value="${state.currentCents}" aria-label="${escapeHtml(copy.label || 'Shipping savings progress')}"></progress>
        <p class="shipping-progress__rates">${escapeHtml(copy.rates || 'Shipping: ₹69 below ₹499; ₹49 from ₹499.')}</p>
      </div>`;
  }

  /* The drawer's struck reference + "Save" lines and its "You save" row. /cart.js carries no compare-at (MRP)
     price, so each bag variant's MRP comes from templates/cart.savings.liquid (/cart?view=savings). MRPs are
     kept here by variant id, since an MRP does not change while a page is open. The bag renders from /cart.js
     straight away. The savings view is requested only when the bag holds a variant not seen yet, and the
     drawer never waits for it: those lines fill in when it lands. If it fails they fill in without MRPs
     (discounts only), and the next render asks again.
     A line's struck reference is MRP × quantity when it has an MRP above its price. Otherwise it is the
     regular line price, struck only when a line discount lowers it. "Save ₹X" = reference − the FINAL line
     price, so struck − final = Save exactly, and a line discount (e.g. Dot & Key buy-3-get-1) is inside it.
     "You save" = MRP total − amount paid = each line's MRP saving + cart.total_discount (automatic discounts
     and codes). It is never the line amounts plus the discount, which would count line discounts twice.
     Same rules as sections/main-cart.liquid. */
  const mrpByVariant = {};
  let cartRender = 0;
  // Until `settled`, a line whose MRP is still unknown stays blank, and so does "You save", so no half-right
  // figure appears and changes a moment later. Once the savings request has settled, an unknown MRP counts as none.
  function fillSavings(body, foot, cart, settled) {
    const slots = body.querySelectorAll('[data-line-save]');
    let youSave = Number(cart.total_discount) || 0, complete = true;
    cart.items.forEach((i, n) => {
      if (!(i.variant_id in mrpByVariant) && !settled) { complete = false; return; }
      const lineMrp = (Number(mrpByVariant[i.variant_id]) || 0) * i.quantity;
      const ref = Math.max(lineMrp, i.original_line_price);
      const mrpPart = window.luveeSaving(i.original_line_price, lineMrp);
      if (mrpPart) youSave += mrpPart.amount;
      const s = window.luveeSaving(i.final_line_price, ref, false);
      if (slots[n]) slots[n].innerHTML = s
        ? `<s class="muted" style="display:block;font-weight:400;font-size:12px"><span class="visually-hidden"> ${lineMrp > i.original_line_price ? 'MRP' : 'Regular price'} </span>${money(ref)}</s>${s.html}`
        : '';
    });
    const you = foot.querySelector('[data-you-save]');
    if (you) you.innerHTML = complete && youSave > 0
      ? `<div style="display:flex;justify-content:space-between;font-size:14px;margin:-6px 0 12px;font-weight:600;color:var(--accent)"><span>You save</span><span>${money(youSave)}</span></div>`
      : '';
  }

  async function renderCart() {
    const body = $('#drawer-body'), foot = $('#drawer-foot');
    const seq = ++cartRender;
    const cart = await fetch('/cart.js').then((r) => r.json());
    if (seq !== cartRender) return;   // a newer render (another tap) has taken over
    updateCount(cart.item_count);
    if (!cart.item_count) {
      body.innerHTML = '<div style="text-align:center;padding:56px 20px"><p style="font-size:30px;margin:0 0 10px">🛍️</p><p style="font-weight:600;margin:0 0 6px">Your bag is feeling light</p><p class="muted" style="font-size:14px;margin:0 0 18px">Let\'s fix that — something lovely is waiting.</p><a href="/collections/bestsellers" class="btn">Browse bestsellers</a></div>';
      foot.innerHTML = ''; return;
    }
    body.innerHTML = cart.items.map((i) => `
      <div style="display:flex;gap:14px;padding:15px 0;border-bottom:1px solid var(--line)">
        <img src="${i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : ''}" alt="" style="width:70px;height:70px;object-fit:contain;background:#fff;border:1px solid var(--line);border-radius:8px;padding:5px">
        <div style="flex:1">
          <div style="font-size:11px;letter-spacing:1px;text-transform:uppercase;color:var(--accent)">${i.vendor || ''}</div>
          <div style="font-size:14px;font-weight:600;line-height:1.3;margin:2px 0 6px">${i.product_title}</div>
          <div style="display:inline-flex;align-items:center;border:1px solid var(--line);border-radius:40px">
            <button data-qty="${i.key}" data-d="-1" style="width:28px;height:28px">−</button>
            <span style="width:30px;text-align:center;font-size:13px">${i.quantity}</span>
            <button data-qty="${i.key}" data-d="1" style="width:28px;height:28px">+</button>
          </div>
        </div>
        <div style="font-weight:600;font-size:14px;white-space:nowrap;text-align:right">${money(i.final_line_price)}<div data-line-save></div></div>
      </div>`).join('') + giftRow();
    gapPicks(cart).then((html) => { if (html && seq === cartRender) body.insertAdjacentHTML('beforeend', html); });
    foot.innerHTML = `
      ${shippingProgress(cart.total_price)}
      ${(() => {
        // Same rule as snippets/delivery-fee.liquid: the store's one domestic rate, priced on the
        // total after discounts. Showing it here means checkout adds nothing the shopper hasn't seen.
        // During the Diwali Dhamaka window the automatic discount makes standard delivery free from
        // ₹999 (same window as shipping-progress.js and delivery-fee.liquid).
        const c = (window.LUVEE && window.LUVEE.shipping) || {};
        const sale = !!(window.LUVEEShippingProgress && window.LUVEEShippingProgress.saleLive && window.LUVEEShippingProgress.saleLive());
        const fee = sale && cart.total_price >= 99900 ? 0 : cart.total_price >= 49900 ? 4900 : 6900;
        const row = 'display:flex;justify-content:space-between;font-size:14px;margin-bottom:6px';
        return `<div style="${row}"><span class="muted">${escapeHtml(c.subtotal || 'Subtotal')}</span><span>${money(cart.total_price)}</span></div>
          <div style="${row};margin-bottom:10px"><span class="muted">${escapeHtml(c.delivery || 'Delivery')}</span><span>${money(fee)}</span></div>
          <div style="display:flex;justify-content:space-between;font-size:18px;font-weight:600;margin-bottom:12px;padding-top:10px;border-top:1px solid var(--line)"><span>${escapeHtml(c.toPay || 'To pay')}</span><span>${money(cart.total_price + fee)}</span></div>
          <div data-you-save></div>`;
      })()}
      <p class="muted" style="font-size:12px;line-height:1.5;margin:0 0 12px">${escapeHtml(window.LUVEE.checkout?.notice || 'Pay online, or choose cash on delivery (₹99 COD charge).')}</p>
      ${window.LUVEE.ordersOpen
        // Shiprocket (Fastrr) fills .shiprocket-headless; theme.liquid hides button[name=checkout] for
        // Indian shoppers and the Fastrr slot for everyone else, so exactly one control shows.
        ? `<div class="shiprocket-headless" data-type="cart"></div>
          <button type="button" name="checkout" class="btn btn--block" onclick="location.href='/checkout'">${escapeHtml(window.LUVEE.checkout?.label || 'Continue to secure checkout')}</button>`
        : '<div style="background:var(--accent-soft);color:var(--accent-dark);font-size:13px;padding:10px 12px;border-radius:8px;text-align:center">We\'re not taking orders yet — launching soon.</div>'}`;
    fillSavings(body, foot, cart, false);   // everything the cache already knows, in the same paint
    if (cart.items.every((i) => i.variant_id in mrpByVariant)) return;
    try {
      const mrp = await fetch('/cart?view=savings', { cache: 'no-store' }).then((r) => (r.ok ? r.json() : {}));
      for (const id in mrp) mrpByVariant[id] = Number(mrp[id]) || 0;
    } catch (e) { /* filled in below without MRPs; the next render asks again */ }
    if (seq === cartRender) fillSavings(body, foot, cart, true);
  }

  // "Add one more" picks for bags under the ₹499 delivery tier. Real products and real payable
  // prices from /collections/under-499?view=picks; the cheapest pick that closes the gap comes
  // first, then the nearest ones under it. Nothing renders when the bag is already ₹499+.
  let picksCache = null;
  async function gapPicks(cart) {
    const gap = 49900 - cart.total_price;
    if (gap <= 0 || !cart.item_count) return '';
    try {
      if (!picksCache) picksCache = await fetch('/collections/under-499?view=picks').then((r) => (r.ok ? r.json() : []));
    } catch (e) { picksCache = []; }
    const inCart = new Set(cart.items.map((i) => i.variant_id));
    const pool = (Array.isArray(picksCache) ? picksCache : []).filter((x) => x && x.price > 0 && !inCart.has(x.id));
    const over = pool.filter((x) => x.price >= gap).sort((a, b) => a.price - b.price);
    const under = pool.filter((x) => x.price < gap).sort((a, b) => b.price - a.price);
    // Three different brands, so the row reads as a choice rather than one brand's shelf.
    const picks = [], brands = new Set();
    for (const x of [...over, ...under]) {
      const brand = (x.vendor || '').toLowerCase();
      if (brands.has(brand)) continue;
      brands.add(brand); picks.push(x);
      if (picks.length === 3) break;
    }
    if (!picks.length) return '';
    return `<div class="gap-picks">
      <p class="gap-picks__title">Add ${money(gap)} more and delivery drops to ₹49</p>
      ${picks.map((x) => `<div class="gap-picks__row">
        ${x.image ? `<img src="${escapeHtml(x.image)}" alt="" width="52" height="52" loading="lazy">` : ''}
        <a class="gap-picks__name" href="${escapeHtml(x.url)}"><span>${escapeHtml(x.vendor || '')}</span>${escapeHtml(x.title)}</a>
        <span class="gap-picks__price">${money(x.price)}${x.was > x.price ? `<s><span class="visually-hidden"> MRP </span>${money(x.was)}</s>` : ''}${(window.luveeSaving(x.price, x.was) || {}).html || ''}</span>
        <button type="button" class="gap-picks__add" data-add="${Number(x.id)}" aria-label="Add ${escapeHtml(x.title)} to bag">+ Add</button>
      </div>`).join('')}
    </div>`;
  }

  function updateCount(n) {
    const el = $('#cart-count'); if (!el) return;
    el.textContent = n; el.hidden = n === 0;
  }

  async function addToCart(id) {
    await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id, quantity: 1 }) });
    openDrawer();
  }
  async function changeQty(key, d) {
    const cart = await fetch('/cart.js').then((r) => r.json());
    const item = cart.items.find((i) => i.key === key); if (!item) return;
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, item.quantity + d) }) });
    // The cart PAGE is server-rendered: re-rendering only the (hidden) drawer left its quantities,
    // discounts and totals showing the old cart after every tap.
    if (document.body.classList.contains('template-cart')) { location.reload(); return; }
    renderCart();
  }

  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-add],[data-qty],#cart-toggle,#drawer-close,#menu-toggle,#m-nav-close');
    if (!t) return;
    if (t.dataset.add !== undefined) { e.preventDefault(); addToCart(+t.dataset.add); }
    else if (t.dataset.qty !== undefined) { changeQty(t.dataset.qty, +t.dataset.d); }
    else if (t.id === 'cart-toggle') { e.preventDefault(); openDrawer(); }
    else if (t.id === 'drawer-close') { closeDrawer(); }
    else if (t.id === 'menu-toggle') { e.preventDefault(); openMenu(); }
    else if (t.id === 'm-nav-close') { closeMenu(); }
  });
  overlay && overlay.addEventListener('click', closeAll);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeAll();
      return;
    }
    if (e.key !== 'Tab' || !mnav || !mnav.classList.contains('is-open')) return;
    const focusables = menuFocusables();
    const first = focusables[0], last = focusables[focusables.length - 1];
    if (!first) return;
    const active = document.activeElement;
    if (e.shiftKey && (active === first || !mnav.contains(active))) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && (active === last || !mnav.contains(active))) {
      e.preventDefault();
      first.focus();
    }
  });

  /* search suggestions — recent (localStorage) + trending, shown on click/focus */
  (function () {
    const form = $('#hdr-search'), input = $('#hdr-search-input'), panel = $('#search-sugg');
    if (!form || !input || !panel) return;
    const KEY = 'luvee-recent-searches';
    const recentWrap = $('#sugg-recent'), recentChips = $('#sugg-recent-chips'), clearBtn = $('#sugg-clear');
    const liveWrap = $('#sugg-live'), trendWrap = $('#sugg-trend');

    const getRecent = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };
    const saveTerm = (t) => {
      t = (t || '').trim(); if (!t) return;
      try {
        const list = [t, ...getRecent().filter((x) => x.toLowerCase() !== t.toLowerCase())].slice(0, 6);
        localStorage.setItem(KEY, JSON.stringify(list));
      } catch {}
    };
    const esc = (s) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

    function renderRecent() {
      const list = getRecent();
      recentWrap.hidden = list.length === 0;
      recentChips.innerHTML = list.map((t) => `
        <a class="search__chip search__chip--recent" href="/search?q=${encodeURIComponent(t)}&type=product" data-sugg-term="${esc(t)}">
          <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 3"/></svg>${esc(t)}
        </a>`).join('');
    }
    function showPanel() { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); }
    function close() { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); }
    function browseMode() { liveWrap.hidden = true; if (trendWrap) trendWrap.hidden = false; renderRecent(); showPanel(); }
    function open() { input.value.trim() === '' ? browseMode() : liveMode(input.value.trim()); }

    /* live predictive results via Shopify's Predictive Search API */
    const money = (v) => window.luveeMoney(Math.round(Number(v) * 100)); // predictive search returns rupees
    let debounceT = null, ctrl = null, lastTerm = '';
    function liveMode(term) {
      if (term === lastTerm && !liveWrap.hidden) { showPanel(); return; }
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      const url = '/search/suggest.json?q=' + encodeURIComponent(term) +
        '&resources[type]=query,product&resources[limit]=6&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor';
      fetch(url, { signal: ctrl.signal }).then((r) => r.json()).then((d) => {
        lastTerm = term;
        const res = (d.resources && d.resources.results) || {};
        const queries = (res.queries || []).slice(0, 4);
        const products = res.products || [];
        let html = '';
        html += queries.map((q) => `
          <a class="sugg-row sugg-row--q" href="/search?q=${encodeURIComponent(q.text)}&type=product" data-sugg-term="${esc(q.text)}">
            <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>
            <span>${esc(q.text)}</span>
          </a>`).join('');
        html += products.map((p) => {
          const img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
          // The API sends rupee strings and no variants, so an MRP and saving are shown only when every
          // variant shares one price and one MRP — otherwise nothing says which variant's MRP it is.
          const cents = (v) => Math.round(Number(v) * 100) || 0;
          const single = cents(p.price_min) === cents(p.price_max) && cents(p.compare_at_price_min) === cents(p.compare_at_price_max);
          const save = single ? window.luveeSaving(cents(p.price), cents(p.compare_at_price_max)) : null;
          return `
          <a class="sugg-row sugg-row--p" href="${p.url}">
            ${img ? `<img src="${img.replace(/(\.[a-z]+)(\?|$)/i, '_80x$1$2')}" alt="" loading="lazy">` : '<span class="sugg-row__ph"></span>'}
            <span class="sugg-row__txt">
              ${p.vendor ? `<small>${esc(p.vendor)}</small>` : ''}
              <span>${esc(p.title)}</span>
            </span>
            <span class="sugg-row__price"><b>${p.price ? money(p.price) : ''}</b>${save ? `<s><span class="visually-hidden"> MRP </span>${money(p.compare_at_price_max)}</s>${save.html}` : ''}</span>
          </a>`;
        }).join('');
        if (!queries.length && !products.length) {
          html = `<p class="sugg-none">Nothing matched "<b>${esc(term)}</b>" yet — try the brand name, or <a href="/#request">request it</a> and we'll hunt it down.</p>`;
        } else {
          html += `<a class="sugg-all" href="/search?q=${encodeURIComponent(term)}&type=product" data-sugg-term="${esc(term)}">See all results for “${esc(term)}” →</a>`;
        }
        liveWrap.innerHTML = html;
        liveWrap.hidden = false;
        recentWrap.hidden = true;
        if (trendWrap) trendWrap.hidden = true;
        showPanel();
      }).catch(() => {});
    }

    input.addEventListener('focus', open);
    input.addEventListener('click', open);
    input.addEventListener('input', () => {
      const v = input.value.trim();
      clearTimeout(debounceT);
      if (v === '') { browseMode(); return; }
      debounceT = setTimeout(() => liveMode(v), 180);
    });
    document.addEventListener('click', (e) => { if (!form.contains(e.target)) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    form.addEventListener('submit', () => saveTerm(input.value));
    panel.addEventListener('click', (e) => {
      const chip = e.target.closest('[data-sugg-term]');
      if (chip) saveTerm(chip.dataset.suggTerm);
    });
    if (clearBtn) clearBtn.addEventListener('click', () => { try { localStorage.removeItem(KEY); } catch {} renderRecent(); });
  })();

  /* gentle scroll-reveal for homepage sections (respects reduced motion) */
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const els = document.querySelectorAll('main .section, main .hero, main .trust-wrap');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach((el) => { el.classList.add('reveal'); io.observe(el); });

    /* Failsafe: reveal anything already on screen at load.
       `.reveal` sets opacity:0 the instant this runs, and the content only comes back when the
       observer reports an intersection. That callback is not guaranteed — with
       `threshold: 0.06` plus a negative bottom rootMargin, a section that is already in view
       when observation starts can fail to produce an entry, and the content then stays
       invisible forever. It bit the 404 page, whose single short section IS the whole page:
       the error message rendered blank on some loads and fine on others.
       Checking geometry directly on the next frame is deterministic where the observer is not.
       Only elements genuinely in the viewport are revealed, so the scroll animation still
       works normally for everything further down. */
    requestAnimationFrame(() => {
      els.forEach((el) => {
        if (el.classList.contains('is-in')) return;
        const r = el.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        if (r.top < vh && r.bottom > 0) { el.classList.add('is-in'); io.unobserve(el); }
      });
    });
  }
})();


/* ---------- Announcement bar rotation ----------
   Cycles the messages rendered by layout/theme.liquid, and bails out for a single message.
   WCAG 2.2.2: rotation pauses while the tab is hidden, while the pointer is over the bar, while focus is
   inside it, and after a touch on it until the next touch elsewhere. A pause/play button (added here,
   since the markup lives in theme.liquid) stops it until the shopper presses play. Under
   prefers-reduced-motion it never starts by itself: the bar shows its first message and the button
   offers play. base.css keeps room for the button from the first paint, so adding it moves nothing. */
(function () {
  const bar = document.getElementById('preview-bar');
  if (!bar || bar.dataset.rotate !== 'true') return;
  const msgs = [...bar.querySelectorAll('.preview-bar__msg')];
  if (msgs.length < 2) return;
  const INTERVAL = 4500;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  let i = msgs.findIndex((m) => m.classList.contains('is-on')), timer = null;
  if (i < 0) { i = 0; msgs[0].classList.add('is-on'); }
  // Why it is paused: the shopper's choice (or reduced motion), or something transient.
  let stopped = reduce.matches, hover = false, focused = false, touched = false;
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'preview-bar__toggle';
  btn.innerHTML = '<svg viewBox="0 0 12 12" width="12" height="12" aria-hidden="true" focusable="false"><path fill="currentColor"/></svg>';
  const icon = btn.querySelector('path');
  bar.appendChild(btn);
  function step() {
    msgs[i].classList.remove('is-on');
    i = (i + 1) % msgs.length;
    msgs[i].classList.add('is-on');
  }
  function update() {
    // The label names the action the button takes, and it changes with the state (no aria-pressed as well).
    btn.setAttribute('aria-label', stopped ? 'Play announcements' : 'Pause announcements');
    icon.setAttribute('d', stopped ? 'M3.5 1.5v9l7-4.5z' : 'M2.5 1.5h2.5v9H2.5zM7 1.5h2.5v9H7z');
    const run = !stopped && !hover && !focused && !touched && !document.hidden;
    if (run && !timer) timer = setInterval(step, INTERVAL);
    else if (!run && timer) { clearInterval(timer); timer = null; }
  }
  btn.addEventListener('click', () => {
    stopped = !stopped;
    // Play means now, even with the pointer, focus or a finger still on the bar.
    if (!stopped) hover = focused = touched = false;
    update();
  });
  document.addEventListener('visibilitychange', update);
  bar.addEventListener('mouseenter', () => { hover = true; update(); });   /* so a message can actually be read */
  bar.addEventListener('mouseleave', () => { hover = false; update(); });
  bar.addEventListener('focusin', () => { focused = true; update(); });
  bar.addEventListener('focusout', (e) => { if (!bar.contains(e.relatedTarget)) { focused = false; update(); } });
  document.addEventListener('touchstart', (e) => {
    const onBar = bar.contains(e.target);
    if (onBar !== touched) { touched = onBar; update(); }
  }, { passive: true });
  const onMotionChange = () => { if (reduce.matches && !stopped) { stopped = true; update(); } };
  if (reduce.addEventListener) reduce.addEventListener('change', onMotionChange);
  else if (reduce.addListener) reduce.addListener(onMotionChange);
  update();
})();
